<h1 mat-dialog-title>{{ "COMMON.DELETE" | translate }}</h1>
<div mat-dialog-content>
  <p>
    {{ "COMMON.DELETE_CONFIRMATION" | translate }} {{ data.deleteContext }}?
  </p>
</div>
<mat-dialog-actions align="end">
  <button mat-raised-button mat-dialog-close>
    {{ "COMMON.CANCEL" | translate }}
  </button>
  <button mat-raised-button color="warn" [mat-dialog-close]="{ delete: true }">
    {{ "COMMON.CONFIRM" | translate }}
  </button>
</mat-dialog-actions>
